module.exports = __webpack_public_path__ + "static/img/3.cd65747.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/3.jpeg
// module id = 41
// module chunks = 1